import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asppharmacy',
  templateUrl: './asppharmacy.component.html',
  styleUrls: ['./asppharmacy.component.scss']
})
export class AsppharmacyComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
